// features/auth/authSlice.ts
import { createSlice } from '@reduxjs/toolkit';

const miscSlice = createSlice({
  name: 'misc',
  initialState: {
    needsLoginRedirect: false
  },
  reducers: {
    authRedirectTriggered(state) {
      state.needsLoginRedirect = true;
    },
    authRedirectHandled(state) {
      state.needsLoginRedirect = false;
    }
  }
});

export const { authRedirectTriggered, authRedirectHandled } = miscSlice.actions;
export const miscReducer = miscSlice.reducer;
